import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ConfirmationService } from 'primeng/api';
import { BusinessPortalService } from '../services/business-portal.services';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { Table } from 'primeng/table';

@Component({
  selector: 'portal-list',
  templateUrl: 'portal-list.component.html',
  standalone: false
})
export class PortalListComponent implements OnInit {
  //#region variables
  private readonly notifications = inject(NotificationService);
  @ViewChild('pt', { static: true }) pt: Table;
  portals: any;
  list: any = [];
  showDialog = false;
  statuses: SelectItem[];
  selectedValue: any;
  cols: any[];
  private subscriptions: Subscription[] = [];
  //#endregion

  //#region constructor
  /**
   * Constructor
   * @param portalservice {BusinessPortalService}
   * @param router {Router}
   * @param route {ActivatedRoute}
   * @param confirmationService {ConfirmationService}
   */
  constructor(
    private portalservice: BusinessPortalService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) {
    this.portals = this.route.snapshot.data['list'];
  }
  //#endregion

  //#region page-events
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.subscriptions.push(
      this.translate.stream('SELECT_STATUS_DROP').subscribe(val => {
        this.statuses = [];
        this.statuses.push(
          { label: val.SELECT, value: null },
          { label: val.INACTIVE, value: 2 },
          { label: val.ACTIVE, value: 1 }
        );
      })
    );
    this.cols = [
      { field: 'Title', header: 'Title', width: '50px', pipe: null },
      { field: 'Users', header: 'Users', width: '50px', pipe: null },
      { field: 'Businesses', header: 'Businesses', width: '150px' },
      { field: 'PortalLogo', header: 'Image', width: '100px' }
    ];
  }
  //#endregion

  //#region control-events
  /**
   * Referesh the portal list
   */
  fetchPortalData() {
    this.subscriptions.push(
      this.portalservice.getAll().subscribe(res => {
        this.portals = res;
      })
    );
  }

  onHide() {
    this.showDialog = false;
    if (this.pt) {
      this.pt.first = 0; // Set the current page to the first page
      this.pt.reset(); // Reset filters and sorting
    }
  }

  showPortalInfo(portalInfo: any[]) {
    this.showDialog = true;
    this.list = [];
    this.list = portalInfo;
  }

  /**
   * Opens confirmation dialog to delete the portal
   * @param portalId ID of the portal to be deleted
   */
  confirm(portalId: number) {
    const messageArray: string[] = [
      this.translate.instant('CONFIRM_DELETE_THIS_PORTAL'),
      '',
      this.translate.instant(
        'ALL_DATA_ASSOCIATED_WITH_THIS_PORTAL_WILL_BE_DELETED'
      ),
      this.translate.instant('BUSINESSES_CAN_BE_REASSIGNED_TO_ANOTHER_PORTAL')
    ];

    this.confirmationService.confirm({
      message: messageArray.join('<br/>'),
      accept: () => {
        this.subscriptions.push(
          this.portalservice.deletePortal(portalId).subscribe(res => {
            this.fetchPortalData();
            this.notifications.success('UI_NOTIFICATIONS.DELETED');
          })
        );
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
  //#endregion
}
